import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Component } from 'react';
import { cascaderClass } from './styles';
import Node from './Node';
import { getLocale } from '../locale';
import { getDirectionClass } from '../utils/classname';
var DefaultProps = {
  id: '',
  parentId: '',
  text: {}
};

var List =
/*#__PURE__*/
function (_Component) {
  _inherits(List, _Component);

  var _super = _createSuper2(List);

  function List(props) {
    var _this;

    _classCallCheck(this, List);

    _this = _super.call(this, props);
    _this.state = {};
    _this.getText = _this.getText.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(List, [{
    key: "getKey",
    value: function getKey(data, index) {
      var _this$props = this.props,
          keygen = _this$props.keygen,
          parentId = _this$props.parentId;
      if (typeof keygen === 'function') return keygen(data, parentId);

      if (keygen && typeof keygen === 'string') {
        var key = data[keygen];

        if (typeof key === 'string' || typeof key === 'number') {
          return key;
        }

        console.error('key must be number or string but get', key);
      }

      return parentId + (parentId ? ',' : '') + index;
    }
  }, {
    key: "getText",
    value: function getText(key) {
      return (this.props.text || {})[key] || getLocale(key);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          data = _this$props2.data,
          other = _objectWithoutProperties(_this$props2, ["data"]);

      if (!data || data.length === 0) return (
        /*#__PURE__*/
        React.createElement("span", {
          className: cascaderClass('no-data')
        }, this.getText('noData'))
      );
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: cascaderClass(getDirectionClass('list'))
        }, data.map(function (d, i) {
          var id = _this2.getKey(d, i);

          return (
            /*#__PURE__*/
            React.createElement(Node, Object.assign({}, other, {
              key: id,
              active: other.id === id,
              id: id,
              data: d
            }))
          );
        }))
      );
    }
  }]);

  return List;
}(Component);

List.defaultProps = DefaultProps;
export default List;